export const CONSENT_KEY = "uc_settings";

export const CONSENTS = {
    KAMELEOON: "9FYjH37-J",
    HOTJAR: "S1kgcNo_j-m",
    REFINER: "_SBGD5koD",
    DATADOG_RUM: "Xl0HIOViY",
} as const;

export type ConsentService = keyof typeof CONSENTS;

/**
 * Check whether the user has given consent for a specific service
 * @param consentId string - The consent ID from CONSENTS
 */
export function hasCookieConsentById(consentId: string): boolean {
    const consentSettings = window.localStorage.getItem(CONSENT_KEY) ?? "";

    if (!consentSettings.length) {
        return false;
    }

    try {
        const consentSettingsObj = JSON.parse(consentSettings) as {
            services?: { id: string; status: boolean }[];
        };

        const servicesAgreement = consentSettingsObj.services;
        if (servicesAgreement) {
            const service = servicesAgreement.find((s) => s.id === consentId);
            return service ? service.status : false;
        }
    } catch (e) {
        console.warn("[Consent] Failed to parse uc_settings", e);
    }

    return false;
}
